const state = {
  pages: [],
  navAction: null,
  activeIndex: 0
}

const mutations = {
  SET_PAGES (state, pages) {
    state.pages = pages || []
  },
  SET_ACTIVE_INDEX (state, index) {
    state.activeIndex = index
  },
  SET_NAV_ACTION (state, action) {
    state.navAction = action
  },
  CLEAR_NAV_ACTION (state) {
    state.navAction = null
  }
}

export default {
  namespaced: true,
  state,
  mutations
}
